import {Injectable} from '@angular/core';

import {AbstractPlatform} from '@app/platform/platform';

@Injectable()
export class WebPlatform extends AbstractPlatform {
    constructor() {
        super();

        this.panelEnabledChange$.next(true);
    }

    // TODO Remove when restartApp is used everywhere
    reboot(): Promise<void> {
        return this.restartApp();
    }

    async restartApp(): Promise<void> {
        window.location.reload();
    }

    getAppUpdateUrl(): string | undefined {
        return window.location.host;
    }

    // TODO Remove when getAppUptime is used everywhere
    getSystemUptime(): number {
        return this.getAppUptime();
    }
}
